<template>
    <template v-if="mode === 'table'">
        <v-btn v-if="v && v!=='null'"
                  class="my-1"
                  variant="text"
                  color="regular"
                  :href=v target="_blank">
        File
  </v-btn>

</template>
    <template v-else-if="mode === 'edit'">
        <!--div class="field">
            <label class="label">{{column.title}}</label>
            
            <div class="control">
                <input class="input" type="text" placeholder="Text input" v-model="v"  @input="handleInput">
            </div>
        </div-->
<!-- <v-btn :label=column.title variant="outlined" v-model="v"  @click="handleInput"></v-btn> -->
<v-file-input label="File" variant="outlined" @input="handleInput"></v-file-input>
        
    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<script>
export default {
    name: 'string-widget',
    props:['mode','column', 'modelValue'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            v: this.modelValue
        }
    },
    methods:{
        handleInput (e) {            
           this.v = e.target.value;            
           this.$emit('update:modelValue', this.v)
        }
    },
}
</script>